import { ContainerGlogal } from "@Components/ContainerGlogal"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native"
import { IconButton } from "react-native-paper"
import { Spacer } from "@Components/Space"
import { useNavigation } from "@react-navigation/native"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useRecoilState } from "recoil"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { CommonActions } from "@react-navigation/native"
import { surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { MaterialCommunityIcons } from "@expo/vector-icons"

export const DiagnosticFinished = ({ routes }) => {
    const navigation = useNavigation()
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)
    const [responseGlobal, setResponseGlobal] = useRecoilState(surveyResponsesAtom)
    const [validating, setValidating] = useState(false)
    const goBackHome = () => {
        setValidating(true)
        setCurrentEducationalDiagnosis(null)
        setResponseGlobal({})
        LocalStorage.resetSurveyResponse().then(() => {
            setValidating(false)
            navigation.replace("Main")
        })
    }

    return (
        <ContainerGlogal style={styles.container}>
            {/* <IconButton
                rippleColor={"rgba(0,0,0,0.05)"}
                onPress={() => goBackHome()}
                icon="close"
                color={"white"}
                size={35}
                style={{ alignSelf: "flex-end" }}
            /> */}

            <TouchableOpacity onPress={() => goBackHome()} style={{ alignSelf: "flex-end", padding: 20 }}>
                <MaterialCommunityIcons name={"close"} size={35} color={"white"} />
            </TouchableOpacity>

            <ScrollView>
                <SvgMascotte style={{ marginVertical: 10 }} width={278} height={278} />
                <OpenSansText color={"white"} fontSize={16} textAlign="center">
                    Vous avez terminé votre Diagnostic Éducatif
                </OpenSansText>

                <View style={{ height: 30 }} />

                <Button
                    disabled={validating}
                    loading={validating}
                    onPress={goBackHome}
                    text="Accueil"
                    width="70%"
                    backgroundColor={"white"}
                    labelColor={baseColors.green.dark}
                />
            </ScrollView>

            <Spacer height={50} />
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: baseColors.green.dark
    }
})
